function table() {
  console.log('table');
  $('table.contenttable, .products__show__description-3 table').each((index, table) => {
    let $table = $(table);
    $table.wrap('<div class="table-responsive"></div>');
  });
}

export default table;
